import { Components, Theme } from '@mui/joy';

declare module '@mui/joy/IconButton' {
  interface IconButtonPropsVariantOverrides {
    topbar: true;
  }
}

export const JoyIconButtonConfig: Partial<Components<Theme>> = {
  JoyIconButton: {
    styleOverrides: {
      root: ({ theme, ownerState }) => {
        const color = ownerState.color && theme.palette[ownerState.color] ? ownerState.color : 'primary';

        return {
          '--Icon-color': 'currentColor',
          borderRadius: '0.25rem',
          '&:disabled': {
            '&:hover': {
              backgroundColor: 'transparent',
            },
            pointerEvents: 'auto',
          },
          ...(ownerState.variant === 'outlined' && {
            border: '1px solid',
            borderColor: theme.palette[color][300],
            backgroundColor: 'var(--joy-palette-common-white)',
            '&:hover:not(:disabled)': {
              backgroundColor: theme.palette.neutral[100],
            },
            '&:disabled': {
              backgroundColor: theme.palette.neutral[200],
            },
          }),
          ...(ownerState.size === 'md' && {
            '--IconButton-size': '2.5rem',
          }),
          ...(ownerState.variant === 'topbar' && {
            '--Icon-color': theme.palette.common.white,
            border: 'unset',
            backgroundColor: 'transparent',
            '&:focus-visible': {
              color: theme.palette.common.white,
            },
            '&:hover': {
              backgroundColor: 'transparent',
              color: theme.palette.neutral[400],
            },
            '&:active': {
              color: theme.palette.neutral[500],
            },
            '&:disabled': {
              '--Icon-color': theme.palette.neutral.solidDisabledColor,
              cursor: 'default',
            },
          }),
        };
      },
    },
    defaultProps: {},
  },
};
